const S3_BASE =
  "https://redoapi-dev.s3.us-east-1.amazonaws.com/redo/static/onboarding-v2";

export const RECLAIM_IMAGE_URL = `${S3_BASE}/onboarding-v2-chargebacks.webp`;
export const RECLAIM_VIDEO_URL = `${S3_BASE}/ReclaimDemo.mp4`;
export const RECLAIM_POSTER_URL = `${S3_BASE}/reclaim_placeholder.png`;
export const RECLAIM_BILLING_IMAGE_URL = `${S3_BASE}/returns_billing.webp`;

/** Colors used across the Reclaim dashboard for dispute outcome visualization. */
export const DISPUTE_COLORS = {
  won: { main: "#d97756", stroke: "#c06545" },
  lost: { main: "#1a1a1a", stroke: "#000" },
  open: { main: "#a3a3a3", stroke: "#8a8a8a" },
} as const;
